// Brand
export const BRAND_NAME = "eon";
// UIKit version
export const UIKIT_VERSION = "4.18.0";

// Font Preload
export const PRELOAD_FONTS = [
  { src: "https://web-ui.eon.com/cdn/fonts/17.0.0/eon/EON_BrixSansWeb-Regular.woff2", type: "font/woff" },
  { src: "https://web-ui.eon.com/cdn/fonts/17.0.0/eon/EON_BrixSansWeb-Medium.woff2", type: "font/woff" },
  { src: "https://web-ui.eon.com/cdn/fonts/17.0.0/eon/EON_BrixSansWeb-Bold.woff2", type: "font/woff" },
  { src: "https://web-ui.eon.com/cdn/fonts/17.0.0/eon/EON_BrixSansWeb-Black.woff2", type: "font/woff" },
  { src: "https://web-ui.eon.com/cdn/fonts/17.0.0/eon/EONScreen-Head.woff2", type: "font/woff" }
] as const;

// businesscardAuthor
export const BUSINESSCARD_AUTHOR_ALIGNMENT_LEFT = "left";
export const BUSINESSCARD_AUTHOR_ALIGNMENT_CENTER = "center";
export const BUSINESSCARD_AUTHOR_ALIGNMENT_RIGHT = "right";
export const BUSINESSCARD_AUTHOR_ALIGNMENT = [
  BUSINESSCARD_AUTHOR_ALIGNMENT_LEFT,
  BUSINESSCARD_AUTHOR_ALIGNMENT_CENTER,
  BUSINESSCARD_AUTHOR_ALIGNMENT_RIGHT
] as const;
export type BusinesscardAuthorAlignment = typeof BUSINESSCARD_AUTHOR_ALIGNMENT[number];
//defaultAlignment
export const BUSINESSCARD_AUTHOR_DEFAULT_ALIGNMENT = "left";

// businesscardContact
export const BUSINESSCARD_CONTACT_ALIGNMENT_LEFT = "left";
export const BUSINESSCARD_CONTACT_ALIGNMENT = [BUSINESSCARD_CONTACT_ALIGNMENT_LEFT] as const;
export type BusinesscardContactAlignment = typeof BUSINESSCARD_CONTACT_ALIGNMENT[number];
//defaultAlignment
export const BUSINESSCARD_CONTACT_DEFAULT_ALIGNMENT = "left";

//Squircle configuration
export const IS_SQUIRCLE = false;

// basicTeaser: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const BASIC_TEASER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER = "center";
export const BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITIONS = [
  BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER,
  BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type BasicTeaserViolatorHorizontalPosition = typeof BASIC_TEASER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// basicTeaser: TYPE || CONTENT_ALIGNMENT
export const BASIC_TEASER_DEFAULT_CONTENT_ALIGNMENT = "left";
export const BASIC_TEASER_CONTENT_ALIGNMENT_LEFT = "left";
export const BASIC_TEASER_CONTENT_ALIGNMENT_CENTER = "center";
export const BASIC_TEASER_CONTENT_ALIGNMENT_PRODUCT = "product";

export const BASIC_TEASER_CONTENT_ALIGNMENTS = [
  BASIC_TEASER_CONTENT_ALIGNMENT_LEFT,
  BASIC_TEASER_CONTENT_ALIGNMENT_CENTER,
  BASIC_TEASER_CONTENT_ALIGNMENT_PRODUCT
] as const;

export type BasicTeaserContentAlignment = typeof BASIC_TEASER_CONTENT_ALIGNMENTS[number];

// box: TYPE || CONTENT_HORIZONTAL_ALIGNMENT
export const BOX_DEFAULT_CONTENT_HORIZONTAL_ALIGNMENT = "left";
export const BOX_CONTENT_HORIZONTAL_ALIGNMENT_LEFT = "left";
export const BOX_CONTENT_HORIZONTAL_ALIGNMENT_CENTER = "center";

export const BOX_CONTENT_HORIZONTAL_ALIGNMENTS = [
  BOX_CONTENT_HORIZONTAL_ALIGNMENT_LEFT,
  BOX_CONTENT_HORIZONTAL_ALIGNMENT_CENTER
] as const;

export type BoxContentHorizontalAlignment = typeof BOX_CONTENT_HORIZONTAL_ALIGNMENTS[number];

// box: TYPE || CONTENT_VERTICAL_ALIGNMENT
export const BOX_DEFAULT_CONTENT_VERTICAL_ALIGNMENT = "top";
export const BOX_CONTENT_VERTICAL_ALIGNMENT_TOP = "top";
export const BOX_CONTENT_VERTICAL_ALIGNMENT_CENTER = "center";
export const BOX_CONTENT_VERTICAL_ALIGNMENT_BOTTOM = "bottom";

export const BOX_CONTENT_VERTICAL_ALIGNMENTS = [
  BOX_CONTENT_VERTICAL_ALIGNMENT_TOP,
  BOX_CONTENT_VERTICAL_ALIGNMENT_CENTER,
  BOX_CONTENT_VERTICAL_ALIGNMENT_BOTTOM
] as const;

export type BoxContentVerticalAlignment = typeof BOX_CONTENT_VERTICAL_ALIGNMENTS[number];

// button: TYPE || ICON_POSITION
export const BUTTON_DEFAULT_ICON_POSITION = "right";
export const BUTTON_ICON_POSITION_LEFT = "left";
export const BUTTON_ICON_POSITION_RIGHT = "right";

export const BUTTON_ICON_POSITIONS = [BUTTON_ICON_POSITION_LEFT, BUTTON_ICON_POSITION_RIGHT] as const;

export type ButtonIconPosition = typeof BUTTON_ICON_POSITIONS[number];

// cardTeaser: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const CARD_TEASER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const CARD_TEASER_VIOLATOR_HORIZONTAL_POSITIONS = [
  CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  CARD_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type CardTeaserViolatorHorizontalPosition = typeof CARD_TEASER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// cardTeaser: TYPE || VIOLATOR_VERTICAL_POSITION
export const CARD_TEASER_DEFAULT_VIOLATOR_VERTICAL_POSITION = "top";
export const CARD_TEASER_VIOLATOR_VERTICAL_POSITION_TOP = "top";
export const CARD_TEASER_VIOLATOR_VERTICAL_POSITION_CENTER = "center";
export const CARD_TEASER_VIOLATOR_VERTICAL_POSITION_BOTTOM = "bottom";

export const CARD_TEASER_VIOLATOR_VERTICAL_POSITIONS = [
  CARD_TEASER_VIOLATOR_VERTICAL_POSITION_TOP,
  CARD_TEASER_VIOLATOR_VERTICAL_POSITION_CENTER,
  CARD_TEASER_VIOLATOR_VERTICAL_POSITION_BOTTOM
] as const;

export type CardTeaserViolatorVerticalPosition = typeof CARD_TEASER_VIOLATOR_VERTICAL_POSITIONS[number];

// cardTeaser: TYPE || PROMO_FLAG_ALIGNMENT
export const CARD_TEASER_DEFAULT_PROMO_FLAG_ALIGNMENT = "left";
export const CARD_TEASER_PROMO_FLAG_ALIGNMENT_LEFT = "left";
export const CARD_TEASER_PROMO_FLAG_ALIGNMENT_CENTER = "center";
export const CARD_TEASER_PROMO_FLAG_ALIGNMENT_RIGHT = "right";

export const CARD_TEASER_PROMO_FLAG_ALIGNMENTS = [
  CARD_TEASER_PROMO_FLAG_ALIGNMENT_LEFT,
  CARD_TEASER_PROMO_FLAG_ALIGNMENT_CENTER,
  CARD_TEASER_PROMO_FLAG_ALIGNMENT_RIGHT
] as const;

export type CardTeaserPromoFlagAlignment = typeof CARD_TEASER_PROMO_FLAG_ALIGNMENTS[number];

// checkbox: TYPE || GROUP_LABEL_FORMAT
export const CHECKBOX_DEFAULT_GROUP_LABEL_FORMAT = "copy";
export const CHECKBOX_GROUP_LABEL_FORMAT_H3 = "h3";
export const CHECKBOX_GROUP_LABEL_FORMAT_H4 = "h4";
export const CHECKBOX_GROUP_LABEL_FORMAT_H5 = "h5";
export const CHECKBOX_GROUP_LABEL_FORMAT_ABSTRACT = "abstract";
export const CHECKBOX_GROUP_LABEL_FORMAT_COPY = "copy";
export const CHECKBOX_GROUP_LABEL_FORMAT_COPY_SMALL = "copy-small";

export const CHECKBOX_GROUP_LABEL_FORMATS = [
  CHECKBOX_GROUP_LABEL_FORMAT_H3,
  CHECKBOX_GROUP_LABEL_FORMAT_H4,
  CHECKBOX_GROUP_LABEL_FORMAT_H5,
  CHECKBOX_GROUP_LABEL_FORMAT_ABSTRACT,
  CHECKBOX_GROUP_LABEL_FORMAT_COPY,
  CHECKBOX_GROUP_LABEL_FORMAT_COPY_SMALL
] as const;

export type CheckboxGroupLabelFormat = typeof CHECKBOX_GROUP_LABEL_FORMATS[number];

// headline: TYPE || ALIGNMENT
export const HEADLINE_DEFAULT_ALIGNMENT = "left";
export const HEADLINE_ALIGNMENT_LEFT = "left";
export const HEADLINE_ALIGNMENT_CENTER = "center";

export const HEADLINE_ALIGNMENTS = [HEADLINE_ALIGNMENT_LEFT, HEADLINE_ALIGNMENT_CENTER] as const;

export type HeadlineAlignment = typeof HEADLINE_ALIGNMENTS[number];

// headlineBrand: TYPE || ALIGNMENT
export const HEADLINE_BRAND_DEFAULT_ALIGNMENT = "left";
export const HEADLINE_BRAND_ALIGNMENT_LEFT = "left";
export const HEADLINE_BRAND_ALIGNMENT_CENTER = "center";

export const HEADLINE_BRAND_ALIGNMENTS = [HEADLINE_BRAND_ALIGNMENT_LEFT, HEADLINE_BRAND_ALIGNMENT_CENTER] as const;

export type HeadlineBrandAlignment = typeof HEADLINE_BRAND_ALIGNMENTS[number];

// image: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const IMAGE_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const IMAGE_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const IMAGE_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const IMAGE_VIOLATOR_HORIZONTAL_POSITIONS = [
  IMAGE_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  IMAGE_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type ImageViolatorHorizontalPosition = typeof IMAGE_VIOLATOR_HORIZONTAL_POSITIONS[number];

// image: TYPE || VIOLATOR_VERTICAL_POSITION
export const IMAGE_DEFAULT_VIOLATOR_VERTICAL_POSITION = "top";
export const IMAGE_VIOLATOR_VERTICAL_POSITION_TOP = "top";
export const IMAGE_VIOLATOR_VERTICAL_POSITION_CENTER = "center";
export const IMAGE_VIOLATOR_VERTICAL_POSITION_BOTTOM = "bottom";

export const IMAGE_VIOLATOR_VERTICAL_POSITIONS = [
  IMAGE_VIOLATOR_VERTICAL_POSITION_TOP,
  IMAGE_VIOLATOR_VERTICAL_POSITION_CENTER,
  IMAGE_VIOLATOR_VERTICAL_POSITION_BOTTOM
] as const;

export type ImageViolatorVerticalPosition = typeof IMAGE_VIOLATOR_VERTICAL_POSITIONS[number];

// link: TYPE || ICON_POSITION
export const LINK_DEFAULT_ICON_POSITION = "right";
export const LINK_ICON_POSITION_LEFT = "left";
export const LINK_ICON_POSITION_RIGHT = "right";

export const LINK_ICON_POSITIONS = [LINK_ICON_POSITION_LEFT, LINK_ICON_POSITION_RIGHT] as const;

export type LinkIconPosition = typeof LINK_ICON_POSITIONS[number];

// multiContentStage: TYPE || PROMO_FLAG_ALIGNMENT
export const MULTI_CONTENT_STAGE_DEFAULT_PROMO_FLAG_ALIGNMENT = "left";
export const MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_LEFT = "left";
export const MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_CENTER = "center";
export const MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_RIGHT = "right";

export const MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENTS = [
  MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_LEFT,
  MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_CENTER,
  MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENT_RIGHT
] as const;

export type MultiContentStagePromoFlagAlignment = typeof MULTI_CONTENT_STAGE_PROMO_FLAG_ALIGNMENTS[number];

// multiContentStage: TYPE || COLOR_BACKGROUNDS
export const MULTI_CONTENT_STAGE_COLOR_BACKGROUNDS_RED500 = "red500";
export const MULTI_CONTENT_STAGE_COLOR_BACKGROUNDS_RED500GRADIENT = "red500gradient";

export const MULTI_CONTENT_STAGE_COLOR_BACKGROUNDSS = [
  MULTI_CONTENT_STAGE_COLOR_BACKGROUNDS_RED500,
  MULTI_CONTENT_STAGE_COLOR_BACKGROUNDS_RED500GRADIENT
] as const;

export type MultiContentStageColorBackgrounds = typeof MULTI_CONTENT_STAGE_COLOR_BACKGROUNDSS[number];

// pageHeader: TYPE || HEADLINE_SIZE
export const PAGE_HEADER_DEFAULT_HEADLINE_SIZE = "h4";
export const PAGE_HEADER_HEADLINE_SIZE_H1 = "h1";
export const PAGE_HEADER_HEADLINE_SIZE_H2 = "h2";
export const PAGE_HEADER_HEADLINE_SIZE_H3 = "h3";
export const PAGE_HEADER_HEADLINE_SIZE_H4 = "h4";
export const PAGE_HEADER_HEADLINE_SIZE_H5 = "h5";

export const PAGE_HEADER_HEADLINE_SIZES = [
  PAGE_HEADER_HEADLINE_SIZE_H1,
  PAGE_HEADER_HEADLINE_SIZE_H2,
  PAGE_HEADER_HEADLINE_SIZE_H3,
  PAGE_HEADER_HEADLINE_SIZE_H4,
  PAGE_HEADER_HEADLINE_SIZE_H5
] as const;

export type PageHeaderHeadlineSize = typeof PAGE_HEADER_HEADLINE_SIZES[number];

// pageHeader: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const PAGE_HEADER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITIONS = [
  PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type PageHeaderViolatorHorizontalPosition = typeof PAGE_HEADER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// pageHeader: TYPE || VIOLATOR_VERTICAL_POSITION
export const PAGE_HEADER_DEFAULT_VIOLATOR_VERTICAL_POSITION = "top";
export const PAGE_HEADER_VIOLATOR_VERTICAL_POSITION_TOP = "top";
export const PAGE_HEADER_VIOLATOR_VERTICAL_POSITION_BOTTOM = "bottom";

export const PAGE_HEADER_VIOLATOR_VERTICAL_POSITIONS = [
  PAGE_HEADER_VIOLATOR_VERTICAL_POSITION_TOP,
  PAGE_HEADER_VIOLATOR_VERTICAL_POSITION_BOTTOM
] as const;

export type PageHeaderViolatorVerticalPosition = typeof PAGE_HEADER_VIOLATOR_VERTICAL_POSITIONS[number];

// pageHeader: TYPE || HORIZONTAL_CONTENT_ALIGNMENT
export const PAGE_HEADER_DEFAULT_HORIZONTAL_CONTENT_ALIGNMENT = "left";
export const PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENT_LEFT = "left";
export const PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENT_CENTER = "center";

export const PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENTS = [
  PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENT_LEFT,
  PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENT_CENTER
] as const;

export type PageHeaderHorizontalContentAlignment = typeof PAGE_HEADER_HORIZONTAL_CONTENT_ALIGNMENTS[number];

// pageHeader: TYPE || VERTICAL_CONTENT_ALIGNMENT
export const PAGE_HEADER_DEFAULT_VERTICAL_CONTENT_ALIGNMENT = "distant";
export const PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENT_DISTANT = "distant";
export const PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENT_CENTER = "center";

export const PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENTS = [
  PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENT_DISTANT,
  PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENT_CENTER
] as const;

export type PageHeaderVerticalContentAlignment = typeof PAGE_HEADER_VERTICAL_CONTENT_ALIGNMENTS[number];

// slider: TYPE || LABEL_FORMAT
export const SLIDER_DEFAULT_LABEL_FORMAT = "copy";
export const SLIDER_LABEL_FORMAT_H3 = "h3";
export const SLIDER_LABEL_FORMAT_H4 = "h4";
export const SLIDER_LABEL_FORMAT_H5 = "h5";
export const SLIDER_LABEL_FORMAT_ABSTRACT = "abstract";
export const SLIDER_LABEL_FORMAT_COPY = "copy";
export const SLIDER_LABEL_FORMAT_COPY_SMALL = "copy-small";

export const SLIDER_LABEL_FORMATS = [
  SLIDER_LABEL_FORMAT_H3,
  SLIDER_LABEL_FORMAT_H4,
  SLIDER_LABEL_FORMAT_H5,
  SLIDER_LABEL_FORMAT_ABSTRACT,
  SLIDER_LABEL_FORMAT_COPY,
  SLIDER_LABEL_FORMAT_COPY_SMALL
] as const;

export type SliderLabelFormat = typeof SLIDER_LABEL_FORMATS[number];

// textTeaser: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const TEXT_TEASER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITIONS = [
  TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type TextTeaserViolatorHorizontalPosition = typeof TEXT_TEASER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// textTeaser: TYPE || PROMO_FLAG_ALIGNMENT
export const TEXT_TEASER_DEFAULT_PROMO_FLAG_ALIGNMENT = "left";
export const TEXT_TEASER_PROMO_FLAG_ALIGNMENT_LEFT = "left";
export const TEXT_TEASER_PROMO_FLAG_ALIGNMENT_CENTER = "center";
export const TEXT_TEASER_PROMO_FLAG_ALIGNMENT_RIGHT = "right";

export const TEXT_TEASER_PROMO_FLAG_ALIGNMENTS = [
  TEXT_TEASER_PROMO_FLAG_ALIGNMENT_LEFT,
  TEXT_TEASER_PROMO_FLAG_ALIGNMENT_CENTER,
  TEXT_TEASER_PROMO_FLAG_ALIGNMENT_RIGHT
] as const;

export type TextTeaserPromoFlagAlignment = typeof TEXT_TEASER_PROMO_FLAG_ALIGNMENTS[number];

// tilesTeaser: TYPE || VIOLATOR_HORIZONTAL_POSITION
export const TILES_TEASER_DEFAULT_VIOLATOR_HORIZONTAL_POSITION = "left";
export const TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT = "left";
export const TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER = "center";
export const TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT = "right";

export const TILES_TEASER_VIOLATOR_HORIZONTAL_POSITIONS = [
  TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_LEFT,
  TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_CENTER,
  TILES_TEASER_VIOLATOR_HORIZONTAL_POSITION_RIGHT
] as const;

export type TilesTeaserViolatorHorizontalPosition = typeof TILES_TEASER_VIOLATOR_HORIZONTAL_POSITIONS[number];

// tilesTeaser: TYPE || CONTENT_ALIGNMENT
export const TILES_TEASER_DEFAULT_CONTENT_ALIGNMENT = "left";
export const TILES_TEASER_CONTENT_ALIGNMENT_LEFT = "left";
export const TILES_TEASER_CONTENT_ALIGNMENT_CENTER = "center";
export const TILES_TEASER_CONTENT_ALIGNMENT_DISTANT = "distant";

export const TILES_TEASER_CONTENT_ALIGNMENTS = [
  TILES_TEASER_CONTENT_ALIGNMENT_LEFT,
  TILES_TEASER_CONTENT_ALIGNMENT_CENTER,
  TILES_TEASER_CONTENT_ALIGNMENT_DISTANT
] as const;

export type TilesTeaserContentAlignment = typeof TILES_TEASER_CONTENT_ALIGNMENTS[number];

// tilesTeaser: TYPE || HORIZONTAL_CONTENT_ALIGNMENT
export const TILES_TEASER_DEFAULT_HORIZONTAL_CONTENT_ALIGNMENT = "left";
export const TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENT_LEFT = "left";
export const TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENT_CENTER = "center";

export const TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENTS = [
  TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENT_LEFT,
  TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENT_CENTER
] as const;

export type TilesTeaserHorizontalContentAlignment = typeof TILES_TEASER_HORIZONTAL_CONTENT_ALIGNMENTS[number];

// tilesTeaser: TYPE || VERTICAL_CONTENT_ALIGNMENT
export const TILES_TEASER_DEFAULT_VERTICAL_CONTENT_ALIGNMENT = "distant";
export const TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT_DISTANT = "distant";
export const TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT_CENTER = "center";

export const TILES_TEASER_VERTICAL_CONTENT_ALIGNMENTS = [
  TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT_DISTANT,
  TILES_TEASER_VERTICAL_CONTENT_ALIGNMENT_CENTER
] as const;

export type TilesTeaserVerticalContentAlignment = typeof TILES_TEASER_VERTICAL_CONTENT_ALIGNMENTS[number];

// violator: TYPE || ALIGNMENT
export const VIOLATOR_DEFAULT_ALIGNMENT = "left";
export const VIOLATOR_ALIGNMENT_LEFT = "left";
export const VIOLATOR_ALIGNMENT_CENTER = "center";

export const VIOLATOR_ALIGNMENTS = [VIOLATOR_ALIGNMENT_LEFT, VIOLATOR_ALIGNMENT_CENTER] as const;

export type ViolatorAlignment = typeof VIOLATOR_ALIGNMENTS[number];

// violator: TYPE || POSITION
export const VIOLATOR_DEFAULT_POSITION = "top";
export const VIOLATOR_POSITION_TOP = "top";
export const VIOLATOR_POSITION_CENTER = "center";
export const VIOLATOR_POSITION_BOTTOM = "bottom";

export const VIOLATOR_POSITIONS = [VIOLATOR_POSITION_TOP, VIOLATOR_POSITION_CENTER, VIOLATOR_POSITION_BOTTOM] as const;

export type ViolatorPosition = typeof VIOLATOR_POSITIONS[number];

// violator: TYPE || PICTOGRAM_POSITION
export const VIOLATOR_DEFAULT_PICTOGRAM_POSITION = "center";

export const VIOLATOR_PICTOGRAM_POSITIONS = [] as const;

export type ViolatorPictogramPosition = typeof VIOLATOR_PICTOGRAM_POSITIONS[number];

//Icon
export const ICON_CDN_URL = "https://web-ui.eon.com/cdn/icons";
export const ICON_VERSION = "3.6.0";

/* Component wise configuration */
// basicTeaser
export const BASIC_TEASER_HEADLINE_SIZES = ["h3", "h4", "h5"] as const;
export const BASIC_TEASER_HEADLINE_SIZE = "h5" as const;
export const BASIC_TEASER_COLORS = ["neutral100", "neutral800"] as const;
// businesscardContact
export const BUSINESSCARD_CONTACT_HEADLINE_SIZE = "h4" as const;
export const BUSINESSCARD_CONTACT_HEADLINE_SEO_TAG = "h4" as const;
// cardTeaser
export const CARD_TEASER_TEXT_POSITION = ["left"] as const;
// contentAggregator
export const CONTENT_AGGREGATOR_BACKGROUND_FOR_COLORFUL_VARIANT = "eon-white" as const;
export const CONTENT_AGGREGATOR_COLORFUL_VARIANT_COLORS = ["yellow300", "turquoise300", "red300"] as const;
export const CONTENT_AGGREGATOR_TILE_BRIGHT_COLOR_SCHEME = "white" as const;
export const CONTENT_AGGREGATOR_TILE_DEFAULT_COLOR_SCHEME = "grey100" as const;
// contentAggregatorItem
export const CONTENT_AGGREGATOR_ITEM_ALTERNATIVE_TAG_PILL_SCHEME = "red500" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_TILE_LARGE = "h3" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_TILE_SMALL = "h4" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_LIST_LARGE = "h5" as const;
export const CONTENT_AGGREGATOR_ITEM_HEADLINE_LIST_SMALL = "copy" as const;
// contextMenuItem
export const CONTEXT_MENU_ITEM_ACTIVE_ICON_SIZE = "small" as const;
// dataTable
export const DATA_TABLE_TOOLBAR_SELECTED_INNER_BACKGROUND = "eon-turquoise100" as const;
export const DATA_TABLE_SEARCH_ICON_NAME = "search" as const;
export const DATA_TABLE_SORT_ICON_NAME = "arrow_up" as const;
export const DATA_TABLE_EXPANDABLE_ICON_NAME = "chevron_small_down" as const;
// dropdown
export const DROPDOWN_CHEVRON_ICON_NAME = "chevron_small_down" as const;
// dropdown
export const DROPDOWN_CHEVRON_SMALL_ICON_NAME = "chevron_small_down" as const;
// footerBar
export const FOOTER_BAR_SHOW_COLOR_SEPARATOR = false as const;
// headline
export const HEADLINE_SCHEMES_ON_BACKGROUND_IMAGE = ["red500", "white"] as const;
// headlineBrand
export const HEADLINE_BRAND_SCHEMES_ON_BACKGROUND_IMAGE = ["red500", "white"] as const;
// icon
export const ICON_ICON_SCHEME = "grey900" as const;
// image
export const IMAGE_COMPONENTS_ON_DARK_IMAGE_BACKGROUND_SCHEME = "eon-red500" as const;
export const IMAGE_COMPONENTS_ON_BRIGHT_IMAGE_BACKGROUND_SCHEME = "eon-white" as const;
// infoIcon
export const INFO_ICON_ICON_NAME = "info" as const;
// modal
export const MODAL_FOOTER_COLORS = ["eon-neutral300"] as const;
export const MODAL_FOOTER_DEFAULT_COLOR = "eon-neutral300" as const;
export const MODAL_HEADLINE_SCHEME = "red500" as const;
export const MODAL_ICON_SCHEME = "neutral800" as const;
export const MODAL_HEADLINE_COLORS = ["red500"] as const;
export const MODAL_DEFAULT_HEADLINE_COLOR = "red500" as const;
// navigation
export const NAVIGATION_TOOLBAR_FLYOUT_INNER_BACKGROUND = "eon-neutral100" as const;
export const NAVIGATION_MAIN_FLYOUT_INNER_BACKGROUND = "eon-neutral100" as const;
export const NAVIGATION_MOBILE_FLYOUT_INNER_BACKGROUND = "eon-neutral100" as const;
export const NAVIGATION_SHOW_COLOR_SEPARATOR = true as const;
// radioButton
export const RADIO_BUTTON_GROUP_LABEL_FORMAT = ["h3", "h4", "h5", "abstract", "copy", "copy-small"] as const;
// section
export const SECTION_SHOW_FOOTER_SEPARATOR = true as const;
// segmentedButton
export const SEGMENTED_BUTTON_GROUP_LABEL_FORMAT = ["h3", "h4", "h5", "abstract", "copy", "copy-small"] as const;
// step
export const STEP_PICTOGRAM_SIZE = "normal" as const;
// textTeaser
export const TEXT_TEASER_HEADLINE_SIZES = ["h3", "h4", "h5"] as const;
export const TEXT_TEASER_HEADLINE_SIZE = "h5" as const;
export const TEXT_TEASER_DEFAULT_HEADLINE_ALIGNMENT = "left" as const;
export const TEXT_TEASER_CONTENT_ALIGNMENT = "left" as const;
export const TEXT_TEASER_PICTOGRAM_ALIGNMENT = "left" as const;
export const TEXT_TEASER_NUMBER_ALIGNMENT = "left" as const;
export const TEXT_TEASER_PICTOGRAM_WITH_NUMBER_ALIGNMENT = "left" as const;
export const TEXT_TEASER_DEFAULT_HEADLINE_WITH_NUMBER_ALIGNMENT = "left" as const;
export const TEXT_TEASER_CONTENT_WITH_NUMBER_ALIGNMENT = "left" as const;
// tooltip
export const TOOLTIP_CONTENT_ALIGNMENT = ["left"] as const;
export const TOOLTIP_DEFAULT_CONTENT_ALIGNMENT = "left" as const;
// videoplayer
export const VIDEOPLAYER_BUTTON_SCHEME = "white" as const;
// videoplayer
export const VIDEOPLAYER_FILLED_ICON = true as const;
// websiteNavigation
export const WEBSITE_NAVIGATION_TOOLBAR_FLYOUT_INNER_BACKGROUND = "eon-neutral300" as const;
export const WEBSITE_NAVIGATION_MAIN_FLYOUT_INNER_BACKGROUND = "eon-neutral300" as const;
export const WEBSITE_NAVIGATION_MOBILE_FLYOUT_INNER_BACKGROUND = "eon-neutral300" as const;
